import axios from 'axios'

if (process.env.NODE_ENV === 'development') {
	axios.defaults.baseURL = 'http://10.70.178.114:5620/'
} else {
	axios.defaults.baseURL = 'https://result.eurolab.am/'
}

export const REFRESH_TOKEN_REFRESH_CYCLE = 280

const TOKEN_API_URL = 'token/'
export const REFRESH_API_URL = 'token/refresh/'

export const accessTokenName = 'access'
export const refreshTokenName = 'refresh'

export const loginSuccess = (access: string, refresh: string) => {
	localStorage.setItem(accessTokenName, access)
	localStorage.setItem(refreshTokenName, refresh)
	setAccesTokenToAxios(access)
}

export const resetLogin = () => {
	localStorage.removeItem(accessTokenName)
	localStorage.removeItem(refreshTokenName)
	setAccesTokenToAxios(undefined)
}

export const setAccesTokenToAxios = (token?: string | null) => {
	axios.defaults.headers.common['Authorization'] = token ? `Bearer ` + token : undefined
}

export const login = async (formData: FormData) => {
	try {
		const res = await axios.post(TOKEN_API_URL, formData)

		if (res.status === 200) {
			loginSuccess(res.data.access, res.data.refresh)
			return true
		} else {
			resetLogin()
		}
	} catch (error) {
		resetLogin()
	}
	return false
}
